<template>
  <div class="teacher-sidebar" :class="{ 'mobile-sidebar': isMobile, 'sidebar-open': !isCollapse && isMobile }" @wheel="handleSidebarWheel">
    <el-menu
      :default-active="activeMenu"
      class="sidebar-menu"
      @select="handleMenuSelect"
      :collapse="isCollapse && !isMobile"
    >
      <!-- 系统账号管理 -->
      <el-sub-menu v-if="showAccountManagement" index="account-management">
        <template #title>
          <img src="/teacher/icon-zhanghao.png" alt="账号管理">
          <span>系统账号管理</span>
        </template>
        <el-menu-item v-if="showMenuItem('teacher-personal-info')" index="teacher-personal-info">修改个人信息</el-menu-item>
        <el-menu-item v-if="showMenuItem('teacher-password-change')" index="teacher-password-change">修改账号密码</el-menu-item>
        <el-menu-item v-if="showMenuItem('admin-management')" index="admin-management">管理员管理</el-menu-item>
        <el-menu-item v-if="showMenuItem('role-management')" index="role-management">角色管理</el-menu-item>
      </el-sub-menu>

      <!-- 网站信息管理 -->
      <el-sub-menu v-if="showWebsiteManagement" index="website-management">
        <template #title>
          <img src="/teacher/icon-wangzhanxinxi.png" alt="信息管理" >
          <span>网站信息管理</span>
        </template>
        <el-menu-item v-if="showMenuItem('course-management')" index="course-management">课程管理</el-menu-item>
        <el-menu-item v-if="showMenuItem('open-course')" index="open-course">公开课</el-menu-item>
        <el-menu-item v-if="showMenuItem('question-management')" index="question-management">试题管理</el-menu-item>
        <el-menu-item v-if="showMenuItem('exam-management')" index="exam-management">试卷管理</el-menu-item>
        <el-menu-item v-if="showMenuItem('study-circle')" index="study-circle">乐学圈</el-menu-item>
        <el-menu-item v-if="showMenuItem('message-push')" index="message-push">消息推送</el-menu-item>
        <!-- <el-menu-item v-if="showMenuItem('teaching-news')" index="teaching-news">教学新闻</el-menu-item> -->
        <el-menu-item v-if="showMenuItem('course-statistics')" index="course-statistics">选课统计</el-menu-item>
        <el-menu-item v-if="showMenuItem('enrollment-records')" index="enrollment-records">选课记录</el-menu-item>
      </el-sub-menu>

      <!-- 设置 -->
      <el-sub-menu v-if="showSettings" index="settings">
        <template #title>
          <img src="/teacher/icon-shezhi.png" alt="设置图片">
          <span>设置</span>
        </template>
        <el-menu-item v-if="showMenuItem('subject-classification')" index="subject-classification">学科分类</el-menu-item>
        <!-- <el-menu-item v-if="showMenuItem('homepage-banner')" index="homepage-banner">首页banner</el-menu-item> -->
        <!-- <el-menu-item v-if="showMenuItem('homepage-column')" index="homepage-column">首页栏目</el-menu-item> -->
        <el-menu-item v-if="showMenuItem('ban-management')" index="ban-management">禁言管理</el-menu-item>
        <el-menu-item v-if="showMenuItem('statistical-report')" index="statistical-report">统计报告</el-menu-item>
      </el-sub-menu>

      <!-- 学院/班级 -->
      <el-sub-menu v-if="showCollegeClass" index="college-class">
        <template #title>
          <img src="/teacher/icon-xuexiao.png" alt="学院/班级图片" style="margin-bottom: 1px;">
          <span>学院/班级</span>
        </template>
        <el-menu-item v-if="showMenuItem('college-management')" index="college-management">学院管理</el-menu-item>
        <el-menu-item v-if="showMenuItem('class-management')" index="class-management">班级管理</el-menu-item>
        <el-menu-item v-if="showMenuItem('student-database')" index="student-database">学生信息库</el-menu-item>
      </el-sub-menu>

      <!-- 空白一级选项，便于滚动 -->
      <el-menu-item index="main-spacer-1" class="spacer-item main-spacer"></el-menu-item>
      <el-menu-item index="main-spacer-2" class="spacer-item main-spacer"></el-menu-item>
      <el-menu-item index="main-spacer-3" class="spacer-item main-spacer"></el-menu-item>
      <el-menu-item index="main-spacer-4" class="spacer-item main-spacer"></el-menu-item>
      <el-menu-item index="main-spacer-5" class="spacer-item main-spacer"></el-menu-item>
    </el-menu>

    <!-- 折叠按钮 -->
    <div class="collapse-btn" @click="toggleCollapse">
      <el-icon>
        <Fold v-if="!isCollapse" />
        <Expand v-else />
      </el-icon>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import {
  Document,
  User,
  UserFilled,
  Setting,
  Fold,
  Expand
} from '@element-plus/icons-vue'
import { useUserStore } from '@/stores/user'
import { useMobile } from '@/composables/useMobile'

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const { isMobile } = useMobile()
const isCollapse = ref(false)
const isManualCollapse = ref(false) // 标记是否为手动收缩
let lastScrollTop = 0

// 暴露收缩状态给父组件
defineExpose({
  isCollapse,
  toggleCollapse: () => toggleCollapse()
})

// 监听移动端状态变化
watch(isMobile, (newVal) => {
  if (newVal) {
    isCollapse.value = true // 移动端默认收起
  } else {
    isCollapse.value = false // PC端默认展开
  }
}, { immediate: true })

// 当前激活的菜单项
  const activeMenu = computed(() => {
    const path = route.path
  if (path === '/teacher' || path === '/teacher/') return 'home'
  if (path.includes('/teacher/courses')) return 'courses'
  if (path.includes('/teacher/students')) return 'students'
  if (path.includes('/teacher/resources')) return 'resources'
  if (path.includes('/teacher/analytics')) return 'teaching-stats'
  if (path.includes('/teacher/profile')) return 'profile'
  if (path.includes('/teacher/settings')) return 'settings'
  if (path.includes('/teacher/content/course-management')) return 'course-management'
  if (path.includes('/teacher/content/enrollment-records')) return 'enrollment-records'
  if (path.includes('/teacher/content/course-statistics')) return 'course-statistics'
  if (path.includes('/teacher/content/course-template')) return 'course-template'
  if (path.includes('/teacher/content/question-management')) return 'question-management'
  if (path.includes('/teacher/content/paper-management')) return 'exam-management'
  if (path.includes('/teacher/content/message-push')) return 'message-push'
  if (path.includes('/teacher/content/teacher-news')) return 'teaching-news'
  if (path.includes('/teacher/content/open-course')) return 'open-course'
  if (path.includes('/teacher/userAccountManagement/TeacherPersonalInformation')) return 'teacher-personal-info'
  if (path.includes('/teacher/userAccountManagement/TeacherPasswordChanged')) return 'teacher-password-change'
  if (path.includes('/teacher/userAccountManagement/TeacherAdminManagement')) return 'admin-management'
  if (path.includes('/teacher/setting/subject-category')) return 'subject-classification'
  if (path.includes('/teacher/setting/banner-management')) return 'homepage-banner'
  if (path.includes('/teacher/setting/homepage-column')) return 'homepage-column'
    if (path.includes('/teacher/setting/muted-management')) return 'ban-management'
    if (path.includes('/teacher/setting/statistical-report')) return 'statistical-report'
  if (path.includes('/teacher/userAccountManagement/TeacherRoleManagement')) return 'role-management'
  if (path.includes('/teacher/content/happy-circle')) return 'study-circle'
  return 'home'
})

const indexRouteNameMap = {
  'teacher-personal-info': 'TeacherPersonalInformation',
  'teacher-password-change': 'TeacherPasswordChanged',
  'admin-management': 'TeacherAdminManagement',
  'role-management': 'TeacherRoleManagement',
  'course-management': 'CourseManagement',
  'question-management': 'QuestionManagement',
  'exam-management': 'PaperManagement',
  'open-course': 'TeacherOpenCourse',
  'study-circle': 'HappyCircle',
  'subject-classification': 'TeacherSubjectCategory',
  'homepage-banner': 'TeacherBannerManagement',
  'homepage-column': 'TeacherHomepageColumn',
  'ban-management': 'TeacherMutedManagement',
  'statistical-report': 'TeacherStatisticalReport',
  'college-management': 'CollegeManagement',
  'class-management': 'ClassManagement',
  'student-database': 'StudentDatabase',
  'enrollment-records': 'EnrollmentRecords',
  'course-statistics': 'CourseStatistics',
  'teaching-news': 'TeacherNews',
  'message-push': 'MessagePush'
}
const showMenuItem = (index) => {
  const name = indexRouteNameMap[index]
  if (!name) return true
  return userStore.hasRouteAccess(name)
}

const showAccountManagement = computed(() => {
  return ['teacher-personal-info', 'teacher-password-change', 'admin-management', 'role-management'].some(showMenuItem)
})

const showWebsiteManagement = computed(() => {
  return ['course-management', 'open-course', 'question-management', 'exam-management', 'study-circle', 'message-push', 'teaching-news', 'course-statistics', 'enrollment-records'].some(showMenuItem)
})

const showSettings = computed(() => {
  return ['subject-classification', 'homepage-banner', 'homepage-column', 'ban-management', 'statistical-report'].some(showMenuItem)
})

const showCollegeClass = computed(() => {
  return ['college-management', 'class-management', 'student-database'].some(showMenuItem)
})

// 菜单选择处理
const handleMenuSelect = (index) => {
  // 忽略空白占位项
  if (index.startsWith('main-spacer-')) {
    return
  }

  // 移动端点击菜单后自动收起
  if (isMobile.value) {
    isCollapse.value = true
  }
  
  // 特殊处理消息推送，需要传入courseId=0参数
  if (index === 'message-push') {
    router.push({
      path: '/teacher/content/message-push',
      query: { courseId: 0 }
    })
    return
  }
  
  const routeMap = {
    'home': '/teacher/home',
    'courses': '/teacher/courses',
    'students': '/teacher/students',
    'resources': '/teacher/resources',
    'resource-categories': '/teacher/resource-categories',
    'teaching-stats': '/teacher/analytics',
    'student-stats': '/teacher/student-stats',
    'resource-stats': '/teacher/resource-stats',
    'profile': '/teacher/profile',
    'settings': '/teacher/settings',
    'course-management': '/teacher/content/course-management',
    'enrollment-records': '/teacher/content/enrollment-records',
    'course-statistics': '/teacher/content/course-statistics',
    'course-template': '/teacher/content/course-template',
    'question-management': '/teacher/content/question-management',
    'exam-management': '/teacher/content/paper-management',
    'teaching-news': '/teacher/content/teacher-news',
    'open-course': '/teacher/content/open-course',
    'teacher-personal-info': '/teacher/userAccountManagement/TeacherPersonalInformation',
    'teacher-password-change': '/teacher/userAccountManagement/TeacherPasswordChanged',
    'admin-management': '/teacher/userAccountManagement/TeacherAdminManagement',
    'role-management': '/teacher/userAccountManagement/TeacherRoleManagement',
    'subject-classification': '/teacher/setting/subject-category',
    'homepage-banner': '/teacher/setting/banner-management',
    'homepage-column': '/teacher/setting/homepage-column',
    'ban-management': '/teacher/setting/muted-management',
    'statistical-report': '/teacher/setting/statistical-report',
    'study-circle': '/teacher/content/happy-circle',
    'college-management': '/teacher/collegesAndClasses/college-management',
    'class-management': '/teacher/collegesAndClasses/class-management',
    'student-database': '/teacher/collegesAndClasses/student-database',
  }
  
  const targetRoute = routeMap[index]
  if (targetRoute) {
    router.push(targetRoute)
  }
}

const toggleCollapse = () => {
  isCollapse.value = !isCollapse.value
  isManualCollapse.value = true
  if (!isCollapse.value) {
    isManualCollapse.value = false
  }
}

const handleScroll = () => {
  if (isMobile.value) return // 移动端不处理滚动收缩逻辑
  
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const windowHeight = window.innerHeight
  const documentHeight = document.documentElement.scrollHeight
  
  const isNearBottom = scrollTop + windowHeight >= documentHeight - 50
  
  const isScrollingDown = scrollTop > lastScrollTop
  
  if (!isManualCollapse.value) {
    if (isNearBottom && isScrollingDown) {
      isCollapse.value = true
    } else if (!isScrollingDown && scrollTop < lastScrollTop - 10) {
      isCollapse.value = false
    }
  }
  
  lastScrollTop = scrollTop
}

// 处理侧边栏滚轮事件，阻止事件冒泡
const handleSidebarWheel = (event) => {
  const sidebar = event.currentTarget
  const { scrollTop, scrollHeight, clientHeight } = sidebar
  
  // 判断滚动方向
  const isScrollingDown = event.deltaY > 0
  
  // 如果向下滚动且已经到底部，或向上滚动且已经到顶部，阻止事件冒泡
  if ((isScrollingDown && scrollTop + clientHeight >= scrollHeight) || 
      (!isScrollingDown && scrollTop <= 0)) {
    event.preventDefault()
    event.stopPropagation()
  }
}

// 组件挂载时添加滚动监听
onMounted(() => {
  window.addEventListener('scroll', handleScroll, { passive: true })
})

// 组件卸载时移除滚动监听
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
/* 移动端样式适配 */
.mobile-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 2000;
  margin-top: 0;
  padding-top: 0;
  border-radius: 0;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
  width: 240px !important; /* 固定宽度 */
}

.mobile-sidebar.sidebar-open {
  transform: translateX(0);
}

.mobile-sidebar .collapse-btn {
  display: none; /* 移动端隐藏底部折叠按钮 */
}

/* 现有样式 */
.teacher-sidebar {
  min-width: 14rem;
  background: #fff;
  border-right: 1px solid #e4e7ed;
  height: calc(100vh - 70px);
  overflow-y: auto;
  overflow-x: visible;
  transition: all 0.3s;
  border-radius: 0 12px 12px 0; /* 右上角和右下角圆角 */
  padding-top: 3rem;
  flex-shrink: 0;
  position: relative;
  margin-top: 20px;
}

.teacher-sidebar:has(.sidebar-menu.el-menu--collapse) {
  width: 64px;
  min-width: 64px;
}

.sidebar-menu {
  border-right: none;
  height: 100%;
  overflow: visible;
}

.sidebar-menu .el-sub-menu__title .el-icon,
.sidebar-menu .el-menu-item .el-icon {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  visibility: visible;
}

.sidebar-menu .el-sub-menu__title .el-icon svg,
.sidebar-menu .el-menu-item .el-icon svg {
  width: 18px;
  height: 18px;
  opacity: 1;
  visibility: visible;
}

.sidebar-menu:not(.el-menu--collapse) {
  width: 100%;
  min-width: 0;
}
.el-sub-menu img {
  margin-right: 7px;
}

/* 收起状态下隐藏文字 */
.sidebar-menu.el-menu--collapse .el-menu-item span,
.sidebar-menu.el-menu--collapse .el-sub-menu__title span,
.sidebar-menu.el-menu--collapse .el-menu-item-group__title {
  display: none;
}

.sidebar-menu.el-menu--collapse .el-menu-item-group__title {
  padding: 0;
  height: 0;
  line-height: 0;
  overflow: hidden;
}

/* 子菜单项样式 */
.sidebar-menu .el-menu-item {
  font-size: 13px;
  position: relative;
  padding-left: 50px !important;
  height: 40px !important;
  line-height: 40px !important;
  white-space: nowrap;
  overflow: visible;
  text-overflow: unset;
}

.sidebar-menu .el-sub-menu__title {
  padding-right: 28px !important;
}

.sidebar-menu .el-sub-menu__icon-arrow {
  right: 12px;
}

/* 确保菜单项文本不被截断 */
.sidebar-menu .el-menu-item span,
.sidebar-menu .el-sub-menu__title span {
  white-space: nowrap;
  overflow: visible;
  text-overflow: unset;
}

/* 为子菜单项添加蓝色圆点 */
.sidebar-menu .el-menu-item::before {
  content: '';
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  background-color: #409eff;
  border-radius: 50%;
  transition: all 0.3s;
}

/* 收起状态下隐藏圆点 */
.sidebar-menu.el-menu--collapse .el-menu-item::before {
  display: none;
}



/* 一级空白选项样式 */
.sidebar-menu .el-menu-item.main-spacer {
  padding-left: 20px !important;
  pointer-events: none;
  background-color: transparent !important;
  color: transparent !important;
  cursor: default;
}

.sidebar-menu .el-menu-item.main-spacer .el-icon {
  display: none;
}

.sidebar-menu .el-menu-item.main-spacer:hover {
  background-color: transparent !important;
  color: transparent !important;
}

.sidebar-menu .el-menu-item.main-spacer::before {
  display: none;
}

.collapse-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  width: 32px;
  height: 32px;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.1s;
  z-index: 1;
}

.collapse-btn .el-icon {
  font-size: 18px;
}

.collapse-btn:hover {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}

/* 隐藏滚动条 */
.teacher-sidebar::-webkit-scrollbar {
  display: none;
}

.teacher-sidebar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

@media (max-width: 768px) {
  .teacher-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 2000;
    margin-top: 0;
    padding-top: 0;
    border-radius: 0;
    width: 240px !important;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
  }
  
  .teacher-sidebar.sidebar-open,
  .teacher-sidebar.mobile-show {
    transform: translateX(0);
  }

  .collapse-btn {
    display: none;
  }
}
</style>
